/**
 * Video Lazy Loader
 * Delays video preload/autoplay until the section is near the viewport.
 * Attach `data-lazy-video` to any section wrapper containing videos.
 * Videos that should autoplay when visible should have a parent with
 * `data-autoplay="true"` or the `.autoplay` class.
 */
(function () {
  'use strict';

  var OBSERVER_MARGIN = '200px';

  function loadVideo(video) {
    if (video.dataset.videoLoaded === 'true') return;
    video.dataset.videoLoaded = 'true';

    video.preload = 'auto';
    video.load();

    var wrapper = video.closest('[data-autoplay="true"], .autoplay');
    if (wrapper) {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }
  }

  function init() {
    var sections = document.querySelectorAll('[data-lazy-video]');
    if (!sections.length) return;

    // Force preload=none on all videos inside lazy sections immediately
    sections.forEach(function (section) {
      section.querySelectorAll('video').forEach(function (video) {
        video.preload = 'none';
        video.autoplay = false;
      });
    });

    if (!('IntersectionObserver' in window)) {
      sections.forEach(function (section) {
        section.querySelectorAll('video').forEach(loadVideo);
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('video').forEach(loadVideo);
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: OBSERVER_MARGIN }
    );

    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
